import type { PlpConfig } from '#types/config/pages/plp'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    breadcrumbs: 'mx-4 mt-3 relative z-1 lg:(mx-6 mt-5)',
    categoryTitle: 'subtitle-2 mx-4 mt-1 lg:mx-6',
    container: '',
    eSpotAboveGrid: '',
    eSpotAboveGridBelowHeading: '',
    productCount: 'body-5 mx-4 lg:hidden'
  },
  breadcrumbsMaxItems: 2,
  seoMetaImage: 'https://images.timberland.com/is/image/timberland/placeholder-image?$496x496$',
  showBreadcrumbsAfterEspot: true,
  showBreadcrumbsLastStep: false,
  sorts: () => ({
    NORA: [
      'bestMatches',
      'priceLowToHigh',
      'priceHighToLow',
      'rating'
    ],
    EMEA: [
      'bestMatches',
      'priceLowToHigh',
      'priceHighToLow',
      'rating',
      'topSellers',
      'whatsNew'
    ]
  }),
  useCustomHeader: true
} satisfies RecursivePartial<PlpConfig>
